import { useState } from 'react';

import type { SkillGroup, SkillItem } from '@pages/PracticePage/model';
import { usePracticeView } from '@pages/PracticePage/model';

import { AIChatModal } from '@widgets/AIChatModal';

import { Heading } from '@shared/ui';

import { PracticeTheoryModal } from './PracticeTheoryModal';
import { SkillItemRow } from './SkillItemRow';

interface SkillGroupListProps {
  groups: SkillGroup[];
}

export const SkillGroupList = ({ groups }: SkillGroupListProps) => {
  const { showDescriptions } = usePracticeView();
  const [selectedSkill, setSelectedSkill] = useState<{
    item: SkillItem;
    groupTitle: string;
  } | null>(null);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [initialMessage, setInitialMessage] = useState<string | undefined>(undefined);

  const handleOpenChat = (message?: string) => {
    setInitialMessage(message);
    setIsChatOpen(true);
  };

  const handleCloseChat = () => {
    setIsChatOpen(false);
    setInitialMessage(undefined);
  };

  return (
    <>
      <div className="flex flex-col gap-6">
        {groups.map((group) => (
          <section key={group.title} className="">
            <Heading tag="h3" size="base" aboveCard>
              {group.title}
            </Heading>
            <div className="mt-3 flex flex-col gap-2">
              {group.items.map((item) => (
                <SkillItemRow
                  key={item.title}
                  item={item}
                  showDescriptions={showDescriptions}
                  onOpen={() => {
                    setSelectedSkill({ item, groupTitle: group.title });
                  }}
                />
              ))}
            </div>
          </section>
        ))}
      </div>

      <PracticeTheoryModal
        isOpen={Boolean(selectedSkill)}
        item={selectedSkill?.item ?? null}
        groupTitle={selectedSkill?.groupTitle}
        onClose={() => {
          setSelectedSkill(null);
        }}
        onOpenChat={handleOpenChat}
      />

      <AIChatModal
        isOpen={isChatOpen}
        onClose={handleCloseChat}
        initialMessage={initialMessage}
        startNewChat
      />
    </>
  );
};
